import React from "react";
import { createUseStyles } from "react-jss";
import PropTypes from "prop-types";
import {
  cardStyles,
  modalGenericStyles,
  variables,
} from "../../../../variables";
import { toast } from "react-toastify";
import GenericBasicInfo from "../../../../components/cards/GenericBasicInfo";
import _ from "lodash";
import { deleteVesselApiConfiguration } from "../../../../api/VesselEngine/ApiConfiguration/ApiConfiguration";
import { genericRequestErrorHandler } from "../../../../api";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import Loader from "../../../../components/Loader";
import { vesselEngineTrueFalseMApping } from "../../common";
import { CustomButton } from "../../../../components/CustomButton";

const styles = createUseStyles({
  ...modalGenericStyles,
  DeleteVesselModal: modalGenericStyles.modal,
  modalCard: modalGenericStyles.card,
  modalCardHeader: modalGenericStyles.cardHeader,
  modalCardBody: {
    ...modalGenericStyles.cardBody,
    display: "grid",
    gridGap: variables.normal_gap,
    gridTemplateRows: "repeat(2, max-content)",
  },
  modalCardActions: modalGenericStyles.cardActions,
  card: cardStyles.card,
  cardBody: cardStyles.body,
});

const DeleteVesselModal = ({ deletedUid, vessel, onClose }) => {
  const classes = styles();
  const queryClient = useQueryClient();

  const basicDataCpl = [
    ["Uid", "uid"],
    ["Name", null, _.capitalize(_.get(vessel, "name"))],
    ["Market Type", "market_type"],
    ["Source Entity", "source_entity"],
    [
      "Is Global",
      null,
      _.get(vesselEngineTrueFalseMApping, _.get(vessel, "is_global")),
    ],
    [
      "Is Own",
      null,
      _.get(vesselEngineTrueFalseMApping, _.get(vessel, "is_own")),
    ],
    ["Website Api Key", "website_api_key"],
    ["Environment", "environment"],
    ["Partner Code", "partner_code"],
  ];

  const deleteVesselApiConfigurationMutation = useMutation(
    deleteVesselApiConfiguration,
    {
      onSuccess: () => {
        toast.success("Vessel Api Configuration Deleted");
        queryClient.invalidateQueries("VesselEngineAPIConfigurations");
        onClose();
      },
      onError: (error) => genericRequestErrorHandler(error),
    }
  );
  const onDelete = () => {
    deleteVesselApiConfigurationMutation.mutate({ uid: deletedUid });
  };

  return (
    <div id="DeleteVesselEngineModal" className={classes.DeleteVesselModal}>
      <div className={classes.modalCard}>
        {deleteVesselApiConfigurationMutation.isLoading && (
          <Loader onTop={true} />
        )}
        <div className={classes.modalCardHeader}>
          <span>DELETE Vessel</span>
        </div>
        <div className={classes.modalCardBody}>
          <div className={classes.card}>
            <div className={classes.cardBody}>
              <GenericBasicInfo
                header={"Are you sure you want to delete this?"}
                cardInfo={basicDataCpl}
                objectData={vessel}
              />
            </div>
          </div>
          <div className={classes.cardActions}>
            <CustomButton
              id="DeleteVesselEngineModalCloseButton"
              appearance="ghost"
              onClick={onClose}>
              <strong>Cancel</strong>
            </CustomButton>
            <CustomButton
              id="DeleteVesselEngineModalConfirmButton"
              appearance="primary"
              onClick={() => {
                onDelete();
              }}>
              <strong>DELETE</strong>
            </CustomButton>
          </div>
        </div>
      </div>
    </div>
  );
};
DeleteVesselModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  vessel: PropTypes.object.isRequired,
  deletedUid: PropTypes.string.isRequired,
};
export default DeleteVesselModal;
